import { z } from "zod";

export const acceptNegotiationSchema = z.object({
  due_at: z.date({ message: 'Campo obrigatório' }),
});

export type AcceptNegotiationValidationSchema = z.infer<typeof acceptNegotiationSchema>;
